// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> astoria
// Generated: 2026-10-08T21:33:15.392Z
// Counts: 2 design, 75 content, 45 slot group, 6 collection binding, 7 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Astoria in Fife, WA, indulge in a lifestyle that blends comfort with convenience. From our inviting clubhouse and state-of-the-art fitness center to a dedicated dog park and BBQ areas, every amenity is designed for relaxation and enjoyment. Unwind and make every moment count in your perfect n<a class=\"richtext-link\" href=\"/floor-plans\">ew home</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Astoria in Fife, WA, we offer an array of thoughtfully designed apartments, including one-, two-, and three-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> tailored to your lifestyle. Whether you seek cozy elegance or spacious comfort, our community is the ideal backdrop for your next chapter. </p><p>Have questions? Contact our leasing team today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Astoria in Fife, WA, your ideal living space awaits. Choose from our thoughtfully designed one-, two-, or three-bedroom floor plans, each tailored for comfort and style. Check out our <a class=\"richtext-link\" href=\"/virtual-tour\">virtual tours</a> and browse our available apartment homes to uncover the perfect layout that fits your lifestyle and makes every day extraordinary. </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Astoria in Fife, WA, envision vibrant living in thoughtfully designed one-, two-, and three-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">apartments</a>. Unwind in our welcoming <a class=\"richtext-link\" href=\"/amenities\">clubhouse</a>, energize in the fitness center, or enjoy playful afternoons at the dog park and playground. Picture yourself thriving here—start your journey with a glimpse into our photo gallery!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Astoria in Fife, WA, your ideal living space awaits. Choose from thoughtfully designed <a class=\"richtext-link\" href=\"/floor-plans\">one-, two-, or three-bedroom floor plans</a>, all nestled within a vibrant community. With amenities like a fitness center, dog park, and BBQ area, life here blends convenience with comfort. Use our interactive community map to begin your journey today! </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in vibrant Fife, WA, Astoria offers more than just stylish one-, two-, and three-bedroom <a class=\"richtext-link\" href=\"/floor-plans\">apartments</a>. Uncover local gems like the Museum of Glass, Washington State History Museum, and picturesque Wright Park. Dive into a world of culture, nature, and community right at your doorstep! Experience life at Astoria today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Dogs and cats are welcome. Maximum of 2 pets per unit. One-time non‑refundable fee: $300 per pet. Refundable deposit: $200 per pet. Monthly pet rent: $50 per pet.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Breed restrictions apply. Contact leasing for details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Astoria, your perfect apartment community nestled in the heart of Fife, WA! Discover a range of <a class=\"richtext-link\" href=\"/floor-plans\">beautifully designed floor plans</a>, including spacious one-bedroom, two-bedroom, and three-bedroom apartments that cater to your unique lifestyle. Each home is thoughtfully crafted with modern finishes and ample living space, ideal for both relaxation and entertaining. </p><p>At Astoria, we prioritize your comfort and convenience with a suite of exceptional <a class=\"richtext-link\" href=\"/amenities\">amenities</a>. Our inviting clubhouse is the perfect spot for social gatherings or quiet afternoons, while the state-of-the-art fitness center allows you to maintain your active lifestyle right at home. Need to focus? Our business center has you covered, making remote work a breeze. Pet lovers will appreciate our dedicated dog wash station and expansive dog park—your furry friends will feel right at home! For outdoor fun, take advantage of our BBQ area or playground. Plus, our ample parking and package locker area provide added convenience, ensuring all your needs are met. </p><p>Astoria is more than just a place to live; it's a community where you can thrive. With its <a class=\"richtext-link\" href=\"/neighborhood\">prime location in Fife</a>, you'll have easy access to shopping, dining, and recreational activities. Don’t wait any longer to find your new home! Browse our availability today or schedule a tour to visit our vibrant community. </p><p>Experience the lifestyle you deserve at Astoria!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Experience the essence of modern living at Astoria in Fife, WA. Choose from spacious <a class=\"richtext-link\" href=\"/floor-plans\">one-, two-, or three-bedroom floor plans</a> designed for comfort and style. Dive into an immersive virtual tour today to see all that our vibrant community has to offer—your new home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Astoria apartment building exterior with landscaping"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019fa50a-7759-7680-9cb4-d3e746e26bb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman with curly hair taking a selfie with her dog."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019d20b7-be96-7637-a3aa-593e5a664c89.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a gray sofa, armchair, fireplace, and large mirror."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Astoria apartment building exterior with landscaping"
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019fa503-2628-7295-b794-9ee80120b472.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A family enjoys a meal together outdoors."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019d02d1-e621-731b-bd5b-614007881fd4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished Astoria apartment living room with a gray sofa, blue accent chair, fireplace, and glass coffee table"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d2-fd7d-713b-ac2e-3376a4d9aa7e.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d1-db2d-72eb-9150-1eba40164220.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d02d1-dae3-7432-a839-1a621ddb0663.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019d20b7-be96-7637-a3aa-593e5a664c89.webp"
      }
    }
  },
  "gallery.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa50a-7759-7680-9cb4-d3e746e26bb7.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Woman with curly hair taking a selfie with her dog."
      }
    }
  },
  "gallery.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa508-a49c-763b-a003-5191eef20cbd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Family enjoying an outdoor meal together, serving pasta and chicken."
      }
    }
  },
  "gallery.lifestyle_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa503-2628-7295-b794-9ee80120b472.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A family enjoys a meal together outdoors."
      }
    }
  },
  "gallery.lifestyle_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa506-e95c-756e-bc58-4d35deed680e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Woman petting her husky dog while sitting on a couch in a bright, modern living room."
      }
    }
  },
  "gallery.lifestyle_image_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa505-f5e7-7436-bc42-7bf162af78c3.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A woman on her phone with a dog relaxing on a leather couch."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0c05-70a0-aa38-70207879e89c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings with covered parking and surrounding landscape."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0c05-70a0-aa38-70207879e89c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment buildings with covered parking and surrounding landscape."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019fa509-8902-713d-b939-c12ca189c969.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Adorable Shih Tzu puppy joyfully running across a green lawn outdoors on a sunny day."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-8ecf-74d6-97ab-181a110e3a00.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with blue and gray siding and manicured landscaping."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-9af9-772f-bb63-7fefaa83d00c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with manicured landscaping in the foreground."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019fa508-a49c-763b-a003-5191eef20cbd.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Family enjoying an outdoor meal together, serving pasta and chicken."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019fa50a-7759-7680-9cb4-d3e746e26bb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman with curly hair taking a selfie with her dog."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-df5e-70ef-b499-a7cfca91a3f0.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-a8cd-7710-ba05-89a025780c85.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-a8f0-737b-9ab9-926a5c731bcf.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-1a80-77bd-96f2-08e9ff3b3dec.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-3455-745e-92cb-b374fefbcc1e.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0c05-70a0-aa38-70207879e89c.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-2700-740c-81cb-ea8a93bd9174.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f388a-0cdd-724d-9363-87a62fe7ec7c.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-a8cd-7710-ba05-89a025780c85.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A brightly lit and modern lobby with blue walls, a grey sofa, two orange accent chairs, a white coffee table, and a television mounted on the wall."
      }
    }
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa503-2628-7295-b794-9ee80120b472.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A family enjoys a meal together outdoors."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Astoria apartment building exterior with landscaping"
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166811/019f3889-ea85-74f9-b924-fe16409e618b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Astoria apartment building exterior with landscaping"
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019fa508-a49c-763b-a003-5191eef20cbd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Family enjoying an outdoor meal together, serving pasta and chicken."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166811/019d20b7-be96-7637-a3aa-593e5a664c89.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Furnished model living room with a gray sofa, armchair, fireplace, and large mirror at Astoria."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": [
      "custom_d649fa0a-f355-4932-b0d6-011cccbbfbc6",
      "custom_5d996fd6-fa58-44b2-a634-7d10b9ab9467",
      "custom_8ac5684e-13f6-4a39-b5ba-cb494f5a7e64",
      "custom_991e1935-689b-439b-90fd-f65c6f828b21",
      "custom_090e26ae-3995-4e15-9232-2a92bf481095",
      "custom_df64c398-5c22-443e-a2af-c8749b6c1d76",
      "custom_f438d46e-cb66-4a66-bbd7-8e0a951839f7",
      "custom_2db9b748-5843-4137-8dd7-4af531132447",
      "custom_2d0e5968-f582-4e6e-ade0-cfe0390a2818",
      "custom_0ed3c5ca-d94f-4490-ba6e-810fed2a8609",
      "custom_9776bc1c-f395-4b3e-874b-825f6e107308",
      "custom_8b5c1eff-b8c3-4e22-a870-a8de0223d960",
      "custom_40081cfe-a05b-462d-8681-59475e4aa36b",
      "custom_1c21fad3-dec9-4554-a85d-102ed232c987",
      "custom_e729d286-de5f-4cdc-b214-d22fc7595bd4",
      "custom_5c5d3370-7bc5-43f5-ba90-bde9e9a41319",
      "custom_988b6f38-3b94-420f-ad55-fc5cce917e0b",
      "custom_9b0db2e5-ce99-4d15-bef4-75f0762a8318",
      "custom_f8940b54-204a-4989-963c-eabe35edb8a6",
      "custom_37e6e632-e4e9-4944-8852-3f2b66c48634",
      "custom_76818dd6-e82e-4996-ac8a-8e565d81b319",
      "custom_5c28c111-87dd-443c-b15b-9dda7de68a21",
      "custom_2cd3a839-b0f9-4e2e-acd5-05d2cf5066b6"
    ],
    "orderedIds": [
      "custom_d85eb544-b0ea-403f-b3cd-c46784375984",
      "custom_87ae5486-d91b-47e3-9d1d-023d1e18fca8",
      "custom_cde9bccb-ac8a-4f0f-b08d-e7874647058d",
      "custom_aee70344-4c5c-4a9e-921c-8e56b6f36bdd",
      "custom_422d4844-d733-4362-806c-c231805d4f17",
      "custom_5b55590f-9f6b-441a-8d6d-679ba299b626",
      "custom_99a68734-7abe-425c-8de8-8d1b4bf8597a",
      "custom_57ecc146-00d9-4303-9106-db084c807200",
      "custom_0ce76044-7322-4fea-b6ad-30080b41c504",
      "custom_6635723e-7749-4741-ac7d-02ec1c4894d0",
      "custom_ca17ae37-b473-4e0a-9a55-5b54b103b7de",
      "custom_b0b0317b-325c-4c9f-815d-4143d1d46b5b",
      "custom_5d996fd6-fa58-44b2-a634-7d10b9ab9467",
      "custom_073abae8-e852-492a-bfa1-0ec2378b3529",
      "custom_991e1935-689b-439b-90fd-f65c6f828b21",
      "custom_169837db-76f6-47ee-9566-f22c832ab2ba",
      "custom_090e26ae-3995-4e15-9232-2a92bf481095",
      "custom_df64c398-5c22-443e-a2af-c8749b6c1d76",
      "custom_f438d46e-cb66-4a66-bbd7-8e0a951839f7",
      "custom_2db9b748-5843-4137-8dd7-4af531132447",
      "custom_2d0e5968-f582-4e6e-ade0-cfe0390a2818",
      "custom_0ed3c5ca-d94f-4490-ba6e-810fed2a8609",
      "custom_9776bc1c-f395-4b3e-874b-825f6e107308",
      "custom_40081cfe-a05b-462d-8681-59475e4aa36b",
      "custom_1c21fad3-dec9-4554-a85d-102ed232c987",
      "custom_e729d286-de5f-4cdc-b214-d22fc7595bd4",
      "custom_9b0db2e5-ce99-4d15-bef4-75f0762a8318",
      "custom_f8940b54-204a-4989-963c-eabe35edb8a6",
      "custom_37e6e632-e4e9-4944-8852-3f2b66c48634",
      "custom_76818dd6-e82e-4996-ac8a-8e565d81b319",
      "custom_5c28c111-87dd-443c-b15b-9dda7de68a21",
      "custom_2cd3a839-b0f9-4e2e-acd5-05d2cf5066b6",
      "custom_26c7407f-4548-40f6-89a5-9bcfeebfd920",
      "custom_48b45288-9da4-4cd6-8918-66cf449de749",
      "custom_f4ff69c9-97b6-4261-9bbf-faf80d7c37dc",
      "custom_0193a588-ddfc-4a46-8f89-561ed83e0c97",
      "custom_0087b090-1286-43ce-bd94-222c7e82c7f2",
      "custom_54a012b8-519f-4de6-868a-7a0aba9bcbad",
      "custom_df353b9e-d4ff-4239-8c95-8111dd03dda9",
      "custom_04ec6c21-c12c-4a43-9a4c-49ff0898e7e3",
      "custom_56ea5b97-c12e-4fcb-a91d-9122ed416779",
      "custom_dcf16773-5ea2-4ab8-b4ba-28c23d500d8b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_e4265ad8-6226-4840-8045-f130f8291f79",
      "custom_0bbbd449-2d52-446a-9881-d7bfe157c489",
      "custom_86b4c50a-8dcd-47e7-9d90-da5d4672024a",
      "custom_3bb14335-f002-431c-a412-ed31fbe68cff",
      "custom_047ab929-d8b9-4d63-a3cc-83072a4d6140",
      "custom_9b4b3adb-3c13-4033-b545-d981d6ba535f",
      "custom_adb579e3-da02-4b6d-8ede-2502ff9f696f",
      "custom_76148b15-c0fe-453a-8a59-719f1ca04789",
      "custom_82e6f182-5d00-44f1-9f34-1a6cc5dc95bd",
      "custom_cc365856-e506-4a7d-9949-2237915b9198",
      "custom_0c08260b-ea74-4f7a-9c0e-f6df71553abb",
      "custom_bf171a1b-eb91-4da8-8368-29dc5de6ef16",
      "custom_301556ea-f307-492e-b36d-511561cd56d7",
      "custom_64ab686a-fa27-4ea5-82f4-f53c08da4e87",
      "custom_1c75ee28-8da3-48dd-8d84-cb66408e0ba4",
      "custom_e6c2dd6c-d726-422f-9b99-3bb523c9a75d",
      "custom_b0b5f44a-7845-4042-8f81-fcf1e4808858",
      "custom_2ce1c77d-de8c-47f0-bc45-802cb3a89e06",
      "custom_a5870267-623c-403e-a7af-17f29ab14e20",
      "custom_75d88961-be69-41d4-8eaa-ae885c4e2ba4",
      "custom_14463644-869a-40f6-826e-532733d84386",
      "custom_ceadbb89-0178-4011-893f-ddf1a56aa83f",
      "custom_fcf01007-2136-41a5-833b-ce3443852e70",
      "custom_6e99cf5e-f98d-4c1b-8610-d800ed06992c",
      "custom_51975395-81d4-40ba-a7bf-0dd7395aac7d",
      "custom_1801e9cb-e2ba-491c-b755-ccdacb2d421c",
      "custom_8a7a74d8-44c1-4ce3-8847-aa2223879fe1",
      "custom_46b0678b-5028-4372-a45a-1ba59635771b",
      "custom_b55aad27-b6da-4cb0-a242-7d3bc22dc376"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_94dc5996-1808-4fc9-b67f-77e53fb2f4e1",
      "custom_9ced1e87-40f2-48c8-9208-f85962541e51",
      "custom_b6163259-4604-4925-b6ee-3dbdee265d16",
      "custom_8f8f1f94-988e-4ef9-ad06-fd4659b3164e",
      "custom_8fc652c8-3adf-4073-b628-72e9890c4970",
      "custom_2c3b3e0b-ab99-4fd3-a0ff-a9b609f780e2",
      "custom_98b94491-b1fc-4c7b-9119-33d790d06a2e",
      "custom_69e3caf9-9f52-4e0b-8b46-475799ceee16",
      "custom_3421d6f2-000b-4020-95a7-4f73f1991370",
      "custom_f1ca5a74-aa4d-45d3-90ac-655dd8f93622",
      "custom_19d33c4d-d63c-4cd7-8930-767ccfbac13c"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_0ed3c5ca-d94f-4490-ba6e-810fed2a8609",
      "custom_f438d46e-cb66-4a66-bbd7-8e0a951839f7"
    ],
    "orderedIds": [
      "custom_99a68734-7abe-425c-8de8-8d1b4bf8597a",
      "custom_aee70344-4c5c-4a9e-921c-8e56b6f36bdd",
      "custom_090e26ae-3995-4e15-9232-2a92bf481095",
      "custom_df64c398-5c22-443e-a2af-c8749b6c1d76",
      "custom_2db9b748-5843-4137-8dd7-4af531132447",
      "custom_2d0e5968-f582-4e6e-ade0-cfe0390a2818",
      "custom_9776bc1c-f395-4b3e-874b-825f6e107308",
      "custom_422d4844-d733-4362-806c-c231805d4f17",
      "custom_6635723e-7749-4741-ac7d-02ec1c4894d0",
      "custom_57ecc146-00d9-4303-9106-db084c807200",
      "custom_0ce76044-7322-4fea-b6ad-30080b41c504",
      "custom_87ae5486-d91b-47e3-9d1d-023d1e18fca8",
      "custom_d85eb544-b0ea-403f-b3cd-c46784375984",
      "custom_cde9bccb-ac8a-4f0f-b08d-e7874647058d",
      "custom_5d996fd6-fa58-44b2-a634-7d10b9ab9467",
      "custom_ca17ae37-b473-4e0a-9a55-5b54b103b7de",
      "custom_b0b0317b-325c-4c9f-815d-4143d1d46b5b",
      "custom_5b55590f-9f6b-441a-8d6d-679ba299b626",
      "custom_073abae8-e852-492a-bfa1-0ec2378b3529",
      "custom_169837db-76f6-47ee-9566-f22c832ab2ba",
      "custom_991e1935-689b-439b-90fd-f65c6f828b21",
      "custom_f438d46e-cb66-4a66-bbd7-8e0a951839f7",
      "custom_0ed3c5ca-d94f-4490-ba6e-810fed2a8609",
      "custom_40081cfe-a05b-462d-8681-59475e4aa36b",
      "custom_1c21fad3-dec9-4554-a85d-102ed232c987",
      "custom_e729d286-de5f-4cdc-b214-d22fc7595bd4",
      "custom_9b0db2e5-ce99-4d15-bef4-75f0762a8318",
      "custom_f8940b54-204a-4989-963c-eabe35edb8a6",
      "custom_37e6e632-e4e9-4944-8852-3f2b66c48634",
      "custom_76818dd6-e82e-4996-ac8a-8e565d81b319",
      "custom_5c28c111-87dd-443c-b15b-9dda7de68a21",
      "custom_2cd3a839-b0f9-4e2e-acd5-05d2cf5066b6",
      "custom_26c7407f-4548-40f6-89a5-9bcfeebfd920",
      "custom_48b45288-9da4-4cd6-8918-66cf449de749",
      "custom_f4ff69c9-97b6-4261-9bbf-faf80d7c37dc",
      "custom_0193a588-ddfc-4a46-8f89-561ed83e0c97",
      "custom_0087b090-1286-43ce-bd94-222c7e82c7f2",
      "custom_54a012b8-519f-4de6-868a-7a0aba9bcbad",
      "custom_df353b9e-d4ff-4239-8c95-8111dd03dda9",
      "custom_04ec6c21-c12c-4a43-9a4c-49ff0898e7e3",
      "custom_56ea5b97-c12e-4fcb-a91d-9122ed416779",
      "custom_dcf16773-5ea2-4ab8-b4ba-28c23d500d8b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.AmenitiesHero": {
    "properties": {
      "textAlign": "center",
      "paddingTop": "0px"
    }
  }
};
